import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ClientePlanejamento } from '../domain/planejamento-cliente.model';

export class ClientePlanejamentoSerializer extends DomainSerializer<ClientePlanejamento> {}
